export default __webpack_public_path__ + "static/media/13-min.dac0346c.PNG";